export const newProvinceConstants = [
  {
    province_code_2: '01',
    province_name_2: 'Thành phố Hà Nội',
  },
  {
    province_code_2: '04',
    province_name_2: 'Tỉnh Cao Bằng',
  },
  {
    province_code_2: '08',
    province_name_2: 'Tỉnh Tuyên Quang',
  },
  {
    province_code_2: '11',
    province_name_2: 'Tỉnh Điện Biên',
  },
  {
    province_code_2: '12',
    province_name_2: 'Tỉnh Lai Châu',
  },
  {
    province_code_2: '14',
    province_name_2: 'Tỉnh Sơn La',
  },
  {
    province_code_2: '15',
    province_name_2: 'Tỉnh Lào Cai',
  },
  {
    province_code_2: '19',
    province_name_2: 'Tỉnh Thái Nguyên',
  },
  {
    province_code_2: '20',
    province_name_2: 'Tỉnh Lạng Sơn',
  },
  {
    province_code_2: '22',
    province_name_2: 'Tỉnh Quảng Ninh',
  },
  {
    province_code_2: '24',
    province_name_2: 'Tỉnh Bắc Ninh',
  },
  {
    province_code_2: '25',
    province_name_2: 'Tỉnh Phú Thọ',
  },
  {
    province_code_2: '31',
    province_name_2: 'Thành phố Hải Phòng',
  },
  {
    province_code_2: '33',
    province_name_2: 'Tỉnh Hưng Yên',
  },
  {
    province_code_2: '37',
    province_name_2: 'Tỉnh Ninh Bình',
  },
  {
    province_code_2: '38',
    province_name_2: 'Tỉnh Thanh Hóa',
  },
  {
    province_code_2: '40',
    province_name_2: 'Tỉnh Nghệ An',
  },
  {
    province_code_2: '42',
    province_name_2: 'Tỉnh Hà Tĩnh',
  },
  {
    province_code_2: '44',
    province_name_2: 'Tỉnh Quảng Trị',
  },
  {
    province_code_2: '46',
    province_name_2: 'Thành phố Huế',
  },
  {
    province_code_2: '48',
    province_name_2: 'Thành phố Đà Nẵng',
  },
  {
    province_code_2: '51',
    province_name_2: 'Tỉnh Quảng Ngãi',
  },
  {
    province_code_2: '52',
    province_name_2: 'Tỉnh Gia Lai',
  },
  {
    province_code_2: '56',
    province_name_2: 'Tỉnh Khánh Hòa',
  },
  {
    province_code_2: '66',
    province_name_2: 'Tỉnh Đắk Lắk',
  },
  {
    province_code_2: '68',
    province_name_2: 'Tỉnh Lâm Đồng',
  },
  {
    province_code_2: '75',
    province_name_2: 'Tỉnh Đồng Nai',
  },
  {
    province_code_2: '79',
    province_name_2: 'Thành phố Hồ Chí Minh',
  },
  {
    province_code_2: '80',
    province_name_2: 'Tỉnh Tây Ninh',
  },
  {
    province_code_2: '82',
    province_name_2: 'Tỉnh Đồng Tháp',
  },
  {
    province_code_2: '86',
    province_name_2: 'Tỉnh Vĩnh Long',
  },
  {
    province_code_2: '91',
    province_name_2: 'Tỉnh An Giang',
  },
  {
    province_code_2: '92',
    province_name_2: 'Thành phố Cần Thơ',
  },
  {
    province_code_2: '96',
    province_name_2: 'Tỉnh Cà Mau',
  },
];
